import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-wrong',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './wrong.component.html',
  styleUrl: './wrong.component.scss'
})
export class WrongComponent {
  @Input() titleKey = 'signup.SomethingWentWrong';
  @Input() subtitleKey = 'signup.UnexpectedError';
  @Input() title?: string;
  @Input() subtitle?: string;

  @Input() primaryLabelKey = 'signup.TryAgain';
  @Input() secondaryLabelKey = 'signup.BackToLogin';
  @Input() primaryLabel?: string;
  @Input() secondaryLabel?: string;

  @Input() portalUrl = 'https://p2-innovate.com/offering/zum-connect-customer-portal/';
  @Input() showFooter = true;

  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
}
